import React from 'react';

function ContactsHidden (props) {
  return (
    <td className='paper col-contacts'>
      <div>
        Контакты скрыты.
        <br />
        Объявление находится в архиве.
      </div>
    </td>
  );
}

ContactsHidden.propTypes = {};
ContactsHidden.defaultProps = {};

export default ContactsHidden;



// WEBPACK FOOTER //
// ./src/ui/Views/Announcements/Cells/PaperCells/ContactsHidden.jsx